import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { LegalFooterComponent } from './legal-footer/legal-footer.component';
import { LoginModalComponent } from './login-modal/login-modal.component';

@NgModule({
  declarations: [LegalFooterComponent],
  imports: [CommonModule, IonicModule, RouterModule, LoginModalComponent],
  exports: [LegalFooterComponent, LoginModalComponent],
})
export class SharedModule {}
